import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@environments';
import posthog from 'posthog-js';

if (environment.POSTHOG_ENABLED_TRACKING) {
  posthog.init(
    environment.POSTHOG_API_KEY,
    {
      api_host: environment.POSTHOG_API_HOST,
      ui_host: environment.POSTHOG_UI_HOST,
      person_profiles: 'identified_only',
      enable_heatmaps: true,
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
      rageclick: true,
    }
  )

  posthog.register({
    default_date: environment.POSTHOG_API_DEFAULTS,
    environment: environment.navType,
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
